import { PERMISSIONS, ROUTE_PATHS } from "./../PermissionsConstants";
import Vendor from "../CarrierAgreementMgmt/Vendor";
import { VendorInvoice } from "../CarrierAgreementMgmt/VendorInvoice";
import {
  BuildingStorefrontIcon,
  ReceiptPercentIcon,
} from "@heroicons/react/24/solid";

export const VendorTabs = [
  {
    to: ROUTE_PATHS.VendorTab_vendor_index,
    component: Vendor,
    label: "Vendor",
    icon: <BuildingStorefrontIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_vendor_view,
  },
  {
    to: ROUTE_PATHS.VendorTab_vendorinvoice_index,
    component: VendorInvoice,
    label: "Vendor Invoice",
    icon: <ReceiptPercentIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_vendorinvoice_view,
  },
];
